import React, { useMemo, useRef, useState } from 'react';
import { Box, Typography, Button, Popover, Stack, ClickAwayListener, Paper } from '@mui/material';
import EditColourDialog from '@/components/HtmlBlockEditor/EditColourDialog';
const ColourPicker = ({ label, initialColour, onChange, disabled = false }) => {
	const colour = useMemo(() => initialColour ?? '#000000', [initialColour]);

	const [showPicker, setShowPicker] = useState(false);

	const ref = useRef();
	const popperRef = useRef();
	const [anchorEl, setAnchorEl] = useState(null);

	const handleColourChange = (newColour) => {
		onChange(newColour);
		setShowPicker(false);
		setAnchorEl(null);
	};

	const showColourPicker = () => {
		if (disabled) return;
		setAnchorEl(ref.current);
		setShowPicker(!showPicker);
	};

	return (
		<Box sx={{ mb: 2 }} width='100%'>
			<Typography variant='subtitle1' sx={{ mb: 1 }}>
				{label}
			</Typography>
			<Stack
				width='100%'
				spacing={1}
				direction='row'
				justifyContent='space-between'
				alignItems={'center'}
			>
				<Box
					sx={(theme) => ({
						width: 36,
						height: 36,
						borderRadius: '4px',
						backgroundColor: colour,
						border: `1px solid ${theme.palette.divider}`,
						cursor: disabled ? 'default' : 'pointer',
						opacity: disabled ? 0.6 : 1,
					})}
					onClick={showColourPicker}
				/>

				<Button
					ref={ref}
					variant='outlined'
					onClick={showColourPicker}
					disabled={disabled}
				>
					{showPicker ? 'Close' : 'Pick Colour'}
				</Button>
			</Stack>

			{showPicker && (
				<Popover
					ref={popperRef}
					anchorEl={anchorEl}
					placement={'left'}
					open={showPicker}
					sx={{
						zIndex: (theme) => theme.zIndex.modal + 1,
					}}
				>
					<EditColourDialog
						open={showPicker}
						block={{ fontColour: colour, backgroundColour: colour }}
						title={label.replace('Colour', '').replace('colour', '').trim()}
						handleClose={() => {
							setShowPicker(false);
							setAnchorEl(null);
						}}
						handleSave={handleColourChange}
						canRemove={false}
					/>
				</Popover>
			)}
		</Box>
	);
};

export default ColourPicker;
